var _slicedToArray = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _require = require('orange-svg'),
  OrangeSVGLine = _require.OrangeSVGLine;
var OrangeChartAbstract = require('./orange-chart-abstract');

/**
 * Abstract chart with X and Y axes
 *
 * @abstract
 */
var OrangeChartAbstractXY = /*#__PURE__*/function (_OrangeChartAbstract) {
  "use strict";

  _inherits(OrangeChartAbstractXY, _OrangeChartAbstract);
  var _super = _createSuper(OrangeChartAbstractXY);
  function OrangeChartAbstractXY() {
    _classCallCheck(this, OrangeChartAbstractXY);
    return _super.apply(this, arguments);
  }
  _createClass(OrangeChartAbstractXY, [{
    key: "_is_vertical",
    value:
    /**
     * Returns chart elements positioning mode
     * @return boolean
     */
    function _is_vertical() {
      return true;
    }

    /**
     * Renders chart
     *
     * @param {OrangeSVG} svg
     * @param {object} view
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @protected
     */
  }, {
    key: "_do_render",
    value: function _do_render(svg, view, x1, y1, x2, y2) {
      this._renderAverageLines(svg, view, x1, y1, x2, y2);
    }

    /**
     * Renders lines with average values
     *
     * @param {OrangeSVG} svg
     * @param {object} view
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @protected
     */
  }, {
    key: "_renderAverageLines",
    value: function _renderAverageLines(svg, view, x1, y1, x2, y2) {
      var width = x2 - x1;
      var height = y2 - y1;
      var real_axis = this._is_vertical ? this._axes.y : this._axes.x;
      var real_scale = real_axis.scale;
      if (view.average_lines || view.all_average_line) {
        var average_lines_values = {};
        if (view.all_average_line) {
          average_lines_values['@all_average'] = [];
        }
        for (var _i = 0, _Object$values = Object.values(this._data); _i < _Object$values.length; _i++) {
          var row = _Object$values[_i];
          for (var _i2 = 0, _Object$values2 = Object.values(this._source_mapping); _i2 < _Object$values2.length; _i2++) {
            var element = _Object$values2[_i2];
            if (!element.hasOwnProperty('property')) {
              throw new Error('"property" should be defined for "element" in properties');
            }
            if (view.average_lines) {
              if (!average_lines_values.hasOwnProperty(element.property)) {
                average_lines_values[element.property] = [];
              }
              average_lines_values[element.property].push(row[element.property]);
            }
            if (view.all_average_line) {
              average_lines_values['@all_average'].push(row[element.property]);
            }
          }
        }
        for (var _i3 = 0, _Object$entries = Object.entries(average_lines_values); _i3 < _Object$entries.length; _i3++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
            property_name = _Object$entries$_i[0],
            property_values = _Object$entries$_i[1];
          var v = (property_values.reduce(function (a, b) {
            return a + b;
          }) / property_values.length - real_scale.min) / (real_scale.max - real_scale.min) * (this._is_vertical ? height : width);
          var average_line_color = property_name === '@all_average' ? typeof view.all_average_line !== 'boolean' ? view.all_average_line : null : typeof view.average_lines === 'object' && view.average_lines[property_name] ? view.average_lines[property_name] : null;
          var average_line = this._is_vertical ? new OrangeSVGLine(x1, height - v + y1, x2, height - v + y1, average_line_color) : new OrangeSVGLine(width - v + x1, y1, width - v + x2, y1, average_line_color);
          average_line.args = {
            'data-property': property_name,
            'class': "orange-chart-average-line"
          };
          svg.appendChild(average_line);
        }
      }
    }
  }]);
  return OrangeChartAbstractXY;
}(OrangeChartAbstract);
module.exports = OrangeChartAbstractXY;